import React from "react";
import styled from "styled-components";

import { Link } from "react-router-dom";
import BaseComponent from "../../BaseComponent.js";
import NanoFlex from "../../Global/NanoFlex.js";
import Type from "../../Global/Typography.js";
import LinkButton from "../../Buttons/LinkButton.js";

import { ReactComponent as LocationIcon } from "./../../Global/icons/locationPin.svg";

//Services
import recruitmentRequestService from "../../../services/RecruitmentRequestService.js";

const StyledOpportunitiesBlock = styled(NanoFlex)`
  border-radius: 10px;
  overflow: hidden;
  height: auto;
  padding: 0 100px;
  gap: 40px;

  a {
    -webkit-user-drag: none;
  }

  .blockTitle {
    .buttonWrapper {
      text-transform: uppercase;
      font-weight: bold;
      font-size: 20px;
      color: ${(props) => props.theme.color.primaryColors.darkPurple};

      svg {
        path {
          stroke: ${(props) => props.theme.color.primaryColors.darkPurple};
        }
      }
    }
  }

  input[type="radio"] {
    display: none;
  }

  #opportunities1:checked ~ .opportunitiesSlider .inner {
    margin-left: 0;
  }
  #opportunities2:checked ~ .opportunitiesSlider .inner {
    margin-left: calc(-100% + 96px);

    @media only screen and (max-width: 1450px) {
      margin-left: calc(-100% + 48px);
    }
  }
  #opportunities3:checked ~ .opportunitiesSlider .inner {
    margin-left: calc(-200% + 192px);

    @media only screen and (max-width: 1450px) {
      margin-left: calc(-200% + 96px);
    }
  }
  #opportunities4:checked ~ .opportunitiesSlider .inner {
    margin-left: calc(-300% + 288px);

    @media only screen and (max-width: 1450px) {
      margin-left: calc(-200% - 144px);
    }
  }
  #opportunities5:checked ~ .opportunitiesSlider .inner {
    margin-left: calc(-400% + 384px);
  }

  .opportunitiesSlider {
    z-index: 1;
    height: auto;
    overflow: hidden;

    .overflow {
      overflow: auto;
      position: relative;
      scrollbar-width: none;

      &::-webkit-scrollbar {
        display: none;
      }

      .inner {
        transition: ${(props) => props.theme.transition};
        min-width: 100%;
        gap: 32px;

        .opportunitiesCard {
          border: 1px solid #adb5bd;
          border-radius: 10px;
          flex: 1 400px;
          min-width: 400px;
          padding: 15px;
          gap: 24px;
          flex-shrink: 0;
          box-shadow: ${(props) => props.theme.lightShaddow};
          margin-bottom: 2px;
          height: 269px;
          cursor: default;

          a {
            width: 100%;
            cursor: pointer;
          }

          .opportunitieHeader {
            height: 100%;
            gap: 5px;
            cursor: pointer;

            h5 {
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              overflow: hidden;
              text-overflow: ellipsis;
              font-weight: 600;
              text-transform: none;
            }
            .opportunitieLocation {
              height: auto;

              p {
                color: ${(props) => props.theme.color.primaryColors.mediumPurple};
              }
              svg {
                height: 18px;
                margin-left: -5px;
                width: auto;

                path,
                circle {
                  stroke: ${(props) => props.theme.color.primaryColors.mediumPurple};
                }
              }
            }
          }

          .opportunitiesArticle {
            height: 100%;
            overflow: hidden;

            p {
              display: -webkit-box;
              -webkit-line-clamp: 3;
              -webkit-box-orient: vertical;
              overflow: hidden;
              text-overflow: ellipsis;
              color: ${(props) => props.theme.color.primaryColors.secFontColor};
            }
            &.noDescription {
              p {
                opacity: 0.36;
              }
            }
          }

          .opportunitiesLabel {
            height: auto;

            &.emptyLabel {
              height: 46px;
              opacity: 0;
            }

            .labelWrapper {
              border-radius: 5px;
              background-color: ${(props) => props.theme.color.primaryColors.labelPurple};
              padding: 12px 24px;

              @media only screen and (max-width: 1450px) {
                padding: 8px 20px;
              }

              @media only screen and (max-width: 1024px) {
                padding: 6px 12px;
              }

              p {
                color: ${(props) => props.theme.color.primaryColors.white};
                text-align: center;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
            }
          }
        }
      }
    }
  }

  /* SMALL DESKTOPS */
  @media only screen and (max-width: 1450px) {
    padding: 0 50px;

    .blockTitle {
      .buttonWrapper {
        font-size: 18px;
      }
    }

    .opportunitiesSlider {
      .overflow {
        .inner {
          .opportunitiesCard {
            flex: 1 400px;
            min-width: 400px;
            height: 239px;

            .opportunitiesLabel {
            }
          }
        }
      }
    }
    .sliderDotsContainer {
      bottom: 20px;
      gap: 32px;

      .sliderDot {
        width: 8px;
        height: 8px;
      }
    }
  }

  /* TABLETS */
  @media only screen and (max-width: 1024px) {
    padding: 0 30px;

    .blockTitle {
      .buttonWrapper {
        font-size: 16px;
      }
    }

    .opportunitiesSlider {
      .overflow {
        .inner {
          .opportunitiesCard {
            flex: 1 250px;
            min-width: 250px;
            gap: 16px;
            height: 185px;

            .opportunitiesArticle {
              p {
                -webkit-line-clamp: 2;
              }
            }
          }
        }
      }
    }
  }

  /* MOBILE */
  @media only screen and (max-width: 815px) {
    padding: 0px 20px;
    gap: 16px;

    h5 {
      font-size: 12px;
    }

    .opportunitiesSlider {
      .overflow {
        .inner {
          gap: 16px;
          .opportunitiesCard {
            border-radius: 5px;
            gap: 16px;
            height: 140px;
          }
        }
      }
    }

    .opportunitiesArticle {
      display: none;
    }

    .blockTitle {
      .title {
        display: none;
      }

      .button {
        width: 100%;
        justify-content: flex-start;
      }
    }
  }

  @media only screen and (max-width: 650px) {
    .opportunitiesSlider {
      .overflow {
        .inner {
          gap: 16px;
        }
      }
    }
  }

  /* MOBILE SMALL*/
  @media only screen and (max-width: 390px) {
    padding: 0 16px;
  }
`;

export default class OpportunitiesBlock extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = this.getDefaultState();
    this.sliderRef = React.createRef();
  }

  getDefaultState = () => {
    return {
      ...this.getDefaultResultsState(),
    };
  };

  getDefaultResultsState = () => {
    return {
      results: [],
      page: 1,
      pageSize: 12,
      interval: null,
      mouseDown: null,
      startX: null,
      scrollLeft: null,
    };
  };

  componentDidMount() {
    super.componentDidMount();
    this.getResults();
    this.startSlide();
  }

  componentWillUnmount() {
    super.componentWillUnmount();
    this.stopSlide();
  }

  getResults = () => {
    let params = {
      page: this.state.page,
      pageSize: this.state.pageSize,
    };
    recruitmentRequestService
      .getRecruitmentRequestWebsiteSharingJobs(params)
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
      })
      .then((data) => {
        this.setState({
          results: data ?? [],
        });
      });
  };

  startSlide = () => {
    this.setState({
      interval: setInterval(this.slide, 120),
      mouseDown: false,
    });
  };

  stopSlide = () => {
    clearInterval(this.state.interval);
  };

  slide = () => {
    if (this.sliderRef.current.scrollLeft === this.sliderRef.current.scrollWidth - this.sliderRef.current.offsetWidth) {
      this.sliderRef.current.scrollTo({
        left: 0,
      });
    }
    this.sliderRef.current.scrollBy({
      left: 3,
      behavior: "smooth",
    });
  };

  mouseDown = (e) => {
    this.setState({
      mouseDown: true,
      mouseMove: true,
      startX: e.pageX - this.sliderRef.current.offsetLeft,
      scrollLeft: this.sliderRef.current.scrollLeft,
    });
  };

  mouseUp = (e) => {
    this.setState({
      mouseDown: false,
    });
  };

  mouseMove = (e) => {
    e.preventDefault();
    if (!this.state.mouseDown) {
      return;
    }
    const x = e.pageX - this.sliderRef.current.offsetLeft;
    const scroll = x - this.state.startX;
    this.sliderRef.current.scrollLeft = this.state.scrollLeft - scroll;
  };

  render() {
    return (
      <StyledOpportunitiesBlock flexDirection="column" className="opportunitiesBlock">
        <NanoFlex className="blockTitle" justifyContent="space-between">
          <Type.h5 className="bold title">{this.translation.homepage.opportunities.blockTitle}</Type.h5>
          <Link to="/recrutamento#opportunitiesBlock">
            <LinkButton label={this.translation.homepage.opportunities.seeMoreOppotunities}></LinkButton>
          </Link>
        </NanoFlex>
        <input type="radio" name="opportunitiesInput" id="opportunities1" defaultChecked />
        <input type="radio" name="opportunitiesInput" id="opportunities2" />
        <input type="radio" name="opportunitiesInput" id="opportunities3" />
        <input type="radio" name="opportunitiesInput" id="opportunities4" />
        <input type="radio" name="opportunitiesInput" id="opportunities5" />

        <NanoFlex className="opportunitiesSlider">
          <NanoFlex className="overflow" ref={this.sliderRef} onMouseEnter={() => this.stopSlide()} onMouseLeave={() => this.startSlide()} onMouseMove={(e) => this.mouseMove(e)} onMouseDown={(e) => this.mouseDown(e)} onMouseUp={(e) => this.mouseUp(e)}>
            <NanoFlex className="inner" justifyContent="flex-start">
              {this.state.results?.map((d) => (
                <NanoFlex className="opportunitiesCard" flexDirection="column" justifyContent="flex-start" data-aos="zoom-in" data-aos-delay="50">
                  <NanoFlex className="opportunitieHeader" flexDirection="column" alignItems="flex-start" justifyContent="flex-start">
                    <Link to={`/recrutamento?id=${d.id}#opportunitiesBlock`}>
                      <Type.h5 className="semiBold">{d.jobTitle}</Type.h5>
                    </Link>
                    {d.location != null ? (
                      <NanoFlex className="opportunitieLocation" justifyContent="flex-start">
                        <LocationIcon />
                        <Type.p>{d.location}</Type.p>
                      </NanoFlex>
                    ) : (
                      <></>
                    )}
                  </NanoFlex>
                  <NanoFlex className={`opportunitiesArticle ${d.functionDescription != null && d.functionDescription != "" ? "" : "noDescription"}`} justifyContent="flex-start" alignItems="flex-start">
                    <Type.p>{d.functionDescription != null && d.functionDescription != "" ? d.functionDescription : this.translation.recruitment.noDescription}</Type.p>
                  </NanoFlex>
                  <Link to={`/recrutamento?id=${d.id}#opportunitiesBlock`}>
                    <NanoFlex className="opportunitiesLabel">
                      <NanoFlex className="labelWrapper">
                        <Type.p>
                          {d.areas != null
                            ? d.areas
                                .map(function (item) {
                                  return item.name;
                                })
                                ?.join(", ") ?? "-"
                            : "-"}
                        </Type.p>
                      </NanoFlex>
                    </NanoFlex>
                  </Link>
                </NanoFlex>
              ))}
            </NanoFlex>
          </NanoFlex>
        </NanoFlex>
      </StyledOpportunitiesBlock>
    );
  }
}
